import React, { Fragment, useContext } from "react";
import ChatAppContext from "../../../Chat";
import { useLocation } from "react-router-dom";
import avatar from "../../../assets/images/avatar.png";
import { capitalize } from "../../Common/CommonFunction";

const ChatHeader = () => {
  const { selectedUser, handalProfileToggle } = useContext(ChatAppContext) || {};
  const location = useLocation();

  const isSupport = selectedUser?.chat_type === "support";

  const peerName = isSupport
    ? (() => {
        const s = (selectedUser?.seeker_id ?? 0) > 0;
        const raw = s
          ? selectedUser?.jobseeker_full_name
          : selectedUser?.recruiter_full_name;
        return (raw || "").trim() || "User";
      })()
    : "";

  const title = isSupport
    ? `Support Chat with ${peerName}`
    : selectedUser?.admin_chat_title ||
      [selectedUser?.jobseeker_full_name, selectedUser?.recruiter_full_name]
        .filter(Boolean)
        .join(" ↔ ") ||
      "";

  const headerImg = isSupport
    ? (selectedUser?.seeker_id ?? 0) > 0
      ? selectedUser?.jobseeker_photo || avatar
      : selectedUser?.profile_image || avatar
    : selectedUser?.jobseeker_photo || avatar;

  return (
    <Fragment>
      <div className="chat-header clearfix" style={{ display: "block" }}>
        <img
          className="rounded-circle"
          src={headerImg}
          alt=""
          onClick={handalProfileToggle}
          style={{ cursor: "pointer" }}
        />
        <div className="media-body">
          <div className="about">
            <div className="name">
              {selectedUser ? capitalize(title) : "Conversation"}
              {isSupport ? (
                <span className="badge bg-info ms-2 f-12">Support Chat</span>
              ) : null}
              {location.state3 ? (
                <span className="font-primary f-12"> Typing...</span>
              ) : null}
            </div>
            <div className="status digits text-muted small">
              {isSupport
                ? "Private conversation between you and this user."
                : "Admin view — messages between jobseeker and recruiter"}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ChatHeader;
